export function buildShopUrl(url: string, gclid: string | null) {
  if (!gclid) return url
  const sep = url.includes('?') ? '&' : '?'
  return url + sep + 'gclid=' + gclid
}

export function trackCTAClick(label: string, position: string) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'cta_click',
    cta_label: label,
    cta_position: position,
    page_type: 'advertorial',
    topic: 'Blähungen',
  })
}
